export default __webpack_public_path__ + "static/media/sabathiL.e1390869.jpg";